import React from 'react';
import PopupMultiple from '../popup/popupMultiple';
import PopupCostOfEquity from '../popup/popupCostOfEquity';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  getAveragePE,
  getAveragePB,
  getAverageFCFE,
} from './../../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';
import './pen-icon.scss';
import enhanceWithClickOutside from 'react-click-outside';
import Const from '../../Const';

const heightPopup = 150;
class Icon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      cursorPosition: null,
    };
  }

  getAverage = (average, type) => {
    const { getAveragePE, getAveragePB } = this.props;
    if (type === Const.typePopUp.peMultiple) {
      getAveragePE(average);
    } else {
      getAveragePB(average);
    }
    this.setState({ isShowPopup: false });
  };

  getFCFE = value => {
    const { getAverageFCFE } = this.props;
    getAverageFCFE(value);
    this.setState({ isShowPopup: false });
  };

  handleClickOutside = () => {
    if (this.state.isShowPopup) {
      this.setState({ isShowPopup: false });
    }
  };

  handleClick = e => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
      cursorPosition: e.clientY,
    });
  };

  render() {
    const { isShowPopup, cursorPosition } = this.state;
    const {
      valuationSector,
      listDataSearch,
      type,
      bottom,
      valuationStock,
    } = this.props;

    return (
      <div>
        <i
          style={{ cursor: 'pointer' }}
          className="icon-edit"
          onClick={e => this.handleClick(e)}
        />{' '}
        {isShowPopup &&
          (type === Const.typePopUp.peMultiple ||
            type === Const.typePopUp.pbMultiple) && (
            <PopupMultiple
              listInfoCheckbox={
                valuationSector ? valuationSector.valuationStocks : null
              }
              finishCaculate={this.getAverage}
              listTickerDefault={listDataSearch}
              type={type}
              isChangePositionPopup={cursorPosition + heightPopup > bottom}
            />
          )}
        {isShowPopup && type === Const.typePopUp.fcfeCostOfEquity && (
          <PopupCostOfEquity
            finishCaculate={this.getFCFE}
            valuationStock={valuationStock}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    averagePE: state[REDUCER_NAME].averagePE,
    valuationSector: state[REDUCER_NAME].valuationSector,
    valuationStock: state[REDUCER_NAME].valuationStock,
    listDataSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  };
};

const mapDispatchToProps = {
  getAveragePE,
  getAveragePB,
  getAverageFCFE,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(enhanceWithClickOutside(Icon));
